module.exports = __webpack_public_path__ + "media/promo/panasonic/images/recipes/rec-5-min-5b9b2898ca79d7c19dc55c353bd2fe62.jpg";